export const scrollToTop = () => {
    try {
        requestAnimationFrame(() => {
            const candidates = [...document.querySelectorAll("div")];
            const mainPanel = candidates.find((el) => {
                const style = getComputedStyle(el);
                const rect = el.getBoundingClientRect();

                return (
                    (style.overflowY === "auto" || style.overflowY === "scroll") &&
                    el.scrollHeight > el.clientHeight + 20 &&
                    rect.width > window.innerWidth * 0.5 && // evita sidebar
                    rect.left < window.innerWidth * 0.3 &&
                    rect.right > window.innerWidth * 0.7
                );
            });

            if (mainPanel) {
                mainPanel.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        });
    } catch (err) {
        console.error("[scrollToTop] error:", err);
    }
};
